// extracted by mini-css-extract-plugin
export default {"selectArrowWrapWidth":"25px","icon":"icon-2Su4SW","label":"label-15W8c0","selectArrowPlaceholder":"selectArrowPlaceholder-106mWO","optionWrap":"optionWrap-1r7_sK"};